import script from "./Ezlab.vue?vue&type=script&setup=true&lang=js"
export * from "./Ezlab.vue?vue&type=script&setup=true&lang=js"

import "./Ezlab.vue?vue&type=style&index=0&id=111db16e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-111db16e"]])

export default __exports__